module.exports = __webpack_public_path__ + "img/symbol_6.096a34be.png";